import { formatFullName } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../ui/UserPhoto/UserPhoto.vue.js';
import { getStore } from '../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'UserBanner',
    components: {
        UserPhoto: __vue_component__,
    },
    props: {
        auth: {
            type: Boolean,
            default: false,
        },
        displayEmail: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object,
            default: undefined,
        },
        include: {
            type: Object,
            default: () => ({
                middleName: false,
                title: false,
            }),
        },
        title: {
            type: String,
            default: undefined,
        },
        useSeededColor: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const store = getStore();
        const userLocal = computed(() => props.user || (props.auth ? store.state.auth.user : undefined));
        const userName = computed(() => userLocal.value ? formatFullName(userLocal.value, props.include.middleName, props.include.title) : store.getters['auth/getUserName']);
        const userEmail = computed(() => {
            var _a, _b, _c;
            return userLocal.value
                ? (_a = userLocal.value.info.email) !== null && _a !== void 0 ? _a : null
                : (_c = (_b = store.getters['auth/getUser']) === null || _b === void 0 ? void 0 : _b.info.email) !== null && _c !== void 0 ? _c : null;
        });
        return {
            userLocal,
            userEmail,
            userName,
        };
    },
});

export { script as default };
